import { ExamCenterProctorRequestStep } from '@exam-center/graphql';

import { useProctorRequestDetails } from '../../providers';
import DraftProctorRequestDetails from '../draft-proctor-request-details/draft-proctor-request-details';
import { ProctorRequestDetailsReadOnlyFields } from '../proctor-request-details-read-only-fields';
import { RejectedProctorRequestDetails } from '../rejected-proctor-request-details';

export default function ProctorRequestDetailsSection() {
  const {
    proctorRequest: { step },
  } = useProctorRequestDetails();

  switch (step) {
    case ExamCenterProctorRequestStep.Draft:
      return <DraftProctorRequestDetails />;
    case ExamCenterProctorRequestStep.InReview_1:
    case ExamCenterProctorRequestStep.InReview_2:
      return <ProctorRequestDetailsReadOnlyFields />;
    case ExamCenterProctorRequestStep.Rejected:
      return <RejectedProctorRequestDetails />;
    default:
      return null;
  }
}
